const RECAPTCHA_LOAD_TIMEOUT = 10000;

export const createRecaptchaToken = async (siteKey, action) => {
  if (!siteKey || !action) {
    throw new Error('reCAPTCHA is not configured.');
  }

  const startedAt = Date.now();
  while (!window.grecaptcha?.ready || !window.grecaptcha?.execute) {
    if (Date.now() - startedAt >= RECAPTCHA_LOAD_TIMEOUT) {
      throw new Error('reCAPTCHA did not load.');
    }
    await new Promise((resolve) => window.setTimeout(resolve, 100));
  }

  // ready() waits for Google's configuration to finish. execute() stays inside this helper so
  // each caller requests a fresh, workflow-specific token immediately before its own request.
  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(siteKey, {action})
        .then(resolve)
        .catch(reject);
    });
  });
};
